module.exports = __webpack_public_path__ + "img/video7.165c4a2c.jpg";